<script setup lang="ts">
  import { computed, watch } from "vue";
  import { storeToRefs } from "pinia";
  import { useRoute } from "vue-router";
  import { RefreshCw } from "lucide-vue-next";
  import OnePanePage from "@templates/OnePanePage.vue";
  import { Button } from "@/components/ui/button";
  import MCampaignPushesTable from "@/components/MCampaign/Pushes/MCampaignPushesTable.vue";
  import { useMCampaignPushesStore } from "@stores/mCampaignPushes";

  const route = useRoute();
  const token = computed(() => route.params.token as string);

  const mCampaignPushesStore = useMCampaignPushesStore();
  const { pushes, failuresByPushId, expandedIds, loading } = storeToRefs(mCampaignPushesStore);
  const { fetchPushes, toggle } = mCampaignPushesStore;

  const refresh = () => fetchPushes(token.value);

  watch(
    token,
    () => {
      if (route.name === "MCampaignPushes") refresh();
    },
    { immediate: true },
  );
</script>

<template>
  <OnePanePage data-cy="master-campaign-pushes-page">
    <div class="flex flex-col gap-4 rounded-xl border bg-background p-6">
      <div class="flex items-start justify-between gap-4">
        <div>
          <h1 class="heading-page">Push history</h1>
          <p class="text-muted-foreground">
            Every push of this campaign to Meta, with the error of each object that failed.
          </p>
        </div>
        <Button
          variant="outline"
          :disabled="loading"
          @click="refresh">
          <RefreshCw class="size-4" />
          Refresh
        </Button>
      </div>
      <MCampaignPushesTable
        :pushes="pushes"
        :failures-by-push-id="failuresByPushId"
        :expanded-ids="expandedIds"
        :loading="loading"
        @toggle="toggle" />
    </div>
  </OnePanePage>
</template>
